import {LAYERFILE} from './LayerFileTypes'

export const addLayerFile = layerFile => {
    return {
        type: LAYERFILE,
        load: layerFile
    }
}

